import { render } from "./SellerRankingTitle.vue?vue&type=template&id=5a66a144&ts=true"
import script from "./SellerRankingTitle.vue?vue&type=script&lang=ts"
export * from "./SellerRankingTitle.vue?vue&type=script&lang=ts"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__